import { api } from './apiClient';

export const fetchHinduFestivalList = async (page = 1, pageSize = 20, searchtext = '') => {
  try {
    const response = await api.post('/api/v1/admin/hindu-festivals/list', {
      pagination: { page, pageSize, sort: { date: 1 } },
      searchtext: searchtext || '',
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || `Server error: ${error.response.status}`);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const createHinduFestival = async (payload) => {
  try {
    const response = await api.post('/api/v1/admin/hindu-festivals', payload);
    return response.data;
  } catch (error) {
    if (error.response) {
      const errorData = error.response.data;
      if (Array.isArray(errorData?.errors)) {
        throw new Error(errorData.errors.join(', '));
      }
      throw new Error(errorData?.message || `Server error: ${error.response.status}`);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const updateHinduFestival = async (payload) => {
  try {
    const response = await api.put('/api/v1/admin/hindu-festivals', payload);
    return response.data;
  } catch (error) {
    if (error.response) {
      const errorData = error.response.data;
      if (Array.isArray(errorData?.errors)) {
        throw new Error(errorData.errors.join(', '));
      }
      throw new Error(errorData?.message || `Server error: ${error.response.status}`);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const deleteHinduFestival = async (id) => {
  try {
    const response = await api.delete(`/api/v1/admin/hindu-festivals/${id}`);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data?.message || `Server error: ${error.response.status}`);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const bulkUploadHinduFestivals = async (items) => {
  try {
    const response = await api.post('/api/v1/admin/hindu-festivals/bulk-upload', items);
    return response.data;
  } catch (error) {
    if (error.response) {
      const errorData = error.response.data;
      throw new Error(JSON.stringify(errorData));
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};
